export const DATE_FORMAT_TIME = 'YYYY-MM-DD HH:mm:ss';

export const PANGU_IDS = {
  development: 1522,
  production: 1521,
};
export const PANGU_TEMPLATE_IDS = {
  development: 1927,
  production: 1928,
};

export const CURRENT_MAINTAINER = 'mclaneyu';

// 本地缓存上一次的登录类型，控制进入wx、rtx、psw登录界面
export const LOGIN_TYPE = {
  wx: 'wx',
  rtx: 'rtx',
  psw: 'psw',
};

export const PAGE_NAME_MAP = {
  myTasks: 'myTasks',
  checkTasks: 'checkTasks',
  checkedTasks: 'checkedTasks',
  reviewTasks: 'reviewTasks',
  projectList: 'projectList',
  samplingTasks: 'samplingTasks',
  iframe: 'iframe',
  botsList: 'botsList',
  qaList: 'qaList',
  noAuth: 'noAuth',
  caiBlindReview: 'caiBlindReview',
  qaReview: 'qaReview',
  ttsBlindReview: 'ttsBlindReview',
  projectListUpgraded: 'projectListUpgraded',
  taskListUpgraded: 'taskListUpgraded',
  qaListUpgraded: 'qaListUpgraded',
  templateList: 'templateList',
  corpusTTSReviewList: 'corpusTTSReviewList',
  comparedTTSReviewList: 'comparedTTSReviewList',
  imgModelReviewList: 'imgModelReviewList',
  imgReflowManageList: 'imgReflowManageList',
  imgBlindReview: 'imgBlindReview',
};

export enum ReportActId {
  CAIDATA_SYS_DATA = 'caidata_sys_data', // 系统数据上报使用-数据看板的数据统计
}

// 系统数据上报节点
export enum ReportActStatus {
  LOGIN = 0, // 登录
  MARK = 1, // 生产
  REVIEW = 2, // 质检
  SAMPLING = 3, // 抽样
  CHECK = 4, // 验收
  CHECKED = 5, // 重新验收
}

export const USER_AUTH_MAP = {
  admin: 1,
  external: 2,
};

// 盘古权限映射map
export const ALL_PANGU_AUTH_ID_MAP: any = {
  development: {
    view_all_task_list: 145329, // 查看/管理所有人的项目/任务列表
    view_all_sys_data: 144849, // 查看系统数据
    mark: 144845, // 生产
    review: 144846, // 质检
    sample: 144847, // 抽检
    check: 144848, // 验收
    manage_project: 144844, // 项目/任务管理
    create_project: 144843, // 创建项目
    tool_config: 144842, // 工具配置
    create_bot: 144841, // 人设导入
    cai_blind_review: 146381, // 盲评
    qa_review: 148343, // 对比复评
    approve_auth: 147069, // 权限审批
    template_manage: 160795, // 模板管理
    image_manage: 171434, // 图片管理
    tts_blind_review: 171934, // 语音包盲评
    corpus_tts_blind_review: 179021, // TTS盲评者
    corpus_tts_blind_review_manage: 179022, // TTS盲评管理员
    corpus_tts_compared_review: 180190, // TTS对比评估者
    corpus_tts_compared_review_manage: 180189, // TTS对比评估管理员
    corpus_img_model_review: 182419, // 图片模型横评者
    corpus_img_model_review_manage: 182420, // 图片模型横评管理员
    corpus_img_model_review_inspect: 185597, // 图片模型横评质检员
    corpus_pipeline_manage: 198549, // 语料管线管理
    corpus_pipeline_project_manage: 202073, // 语料管线-项目经理
    corpus_pipeline_project_mark: 202074, // 语料管线-生产者
    corpus_pipeline_project_review: 202075, // 语料管线-质检人
    h5_eval_review: 204272, // H5对话评估
    h5_eval_review_manage: 204273, // H5对话评估管理
    img_blind_review: 203946, // 图片盲评
    img_blind_review_manage: 203947, // 图片盲评管理员
  },
  production: {
    view_all_task_list: 145914, // 查看/管理所有人的项目/任务列表
    view_all_sys_data: 145913, // 查看系统数据
    mark: 145909, // 生产
    review: 145910, // 质检
    sample: 145911, // 抽检
    check: 145912, // 验收
    manage_project: 145908, // 项目/任务管理
    create_project: 145907, // 创建项目
    tool_config: 145906, // 工具配置
    create_bot: 144914, // 人设导入
    cai_blind_review: 146383, // 盲评
    qa_review: 148344, // 对比复评
    approve_auth: 147070, // 权限审批
    template_manage: 160796, // 模板管理
    image_manage: 171435, // 图片管理
    tts_blind_review: 171935, // 语音包盲评
    corpus_tts_blind_review: 179024, // TTS盲评者
    corpus_tts_blind_review_manage: 179023, // TTS盲评管理员
    corpus_tts_compared_review: 180192, // TTS对比评估者
    corpus_tts_compared_review_manage: 180191, // TTS对比评估管理员
    corpus_img_model_review: 182421, // 图片模型横评者
    corpus_img_model_review_manage: 182422, // 图片模型横评管理员
    corpus_img_model_review_inspect: 185596, // 图片模型横评质检员
    corpus_pipeline_manage: 198550, // 语料管线管理
    corpus_pipeline_project_manage: 202077, // 语料管线-项目经理
    corpus_pipeline_project_mark: 202078, // 语料管线-生产者
    corpus_pipeline_project_review: 202079, // 语料管线-质检人
    h5_eval_review: 204274, // H5对话评估
    h5_eval_review_manage: 204275, // H5对话评估管理
    img_blind_review: 204022, // 图片盲评
    img_blind_review_manage: 204023, // 图片盲评管理员
  },
};
// 盘古角色映射map-微信暴露
export const ALL_WX_PANGU_ROLE_ID_MAP: any = {
  development: {
    mark: { value: 281963, label: '生产者' }, // 生产
    review: { value: 281964, label: '质检者' }, // 质检
    blind_review: { value: 285687, label: '模型盲评者' }, // 模型盲评
    tts_blind_review: { value: 306593, label: '语音包盲评者' }, // 语音包盲评
    corpus_tts_blind_review: { value: 308976, label: 'TTS盲评者' }, // TTS盲评者
    corpus_tts_compared_review: { value: 309987, label: 'TTS对比评估者' }, // TTS对比评估者
    corpus_img_model_review: { value: 314062, label: '图片模型横评者' }, // 图片模型横评者
    corpus_img_model_review_inspect: { value: 671297, label: '图片模型横评质检员' }, // 图片模型横评质检员
    corpus_pipeline_project_mark: { value: 677727, label: '语料管线-生产者' }, // 语料管线-生产者
    corpus_pipeline_project_review: { value: 677728, label: '语料管线-质检人' }, // 语料管线-质检人
    h5_eval_review: { value: 678757, label: 'h5对话评估者' }, // h5对话评估者
    img_blind_review: { value: 678637, label: '图片盲评者' }, // 图片盲评者
  },
  production: {
    mark: { value: 284945, label: '生产者' }, // 生产
    review: { value: 284946, label: '质检者' }, // 质检
    blind_review: { value: 285684, label: '模型盲评者' }, // 模型盲评
    tts_blind_review: { value: 306594, label: '语音包盲评者' }, // 语音包盲评
    corpus_tts_blind_review: { value: 308974, label: 'TTS盲评者' }, // TTS盲评者
    corpus_tts_compared_review: { value: 309989, label: 'TTS对比评估者' }, // TTS对比评估者
    corpus_img_model_review: { value: 314060, label: '图片模型横评者' }, // 图片模型横评者
    corpus_img_model_review_inspect: { value: 671296, label: '图片模型横评质检员' }, // 图片模型横评质检员
    corpus_pipeline_project_mark: { value: 677730, label: '语料管线-生产者' }, // 语料管线-生产者
    corpus_pipeline_project_review: { value: 677731, label: '语料管线-质检人' }, // 语料管线-质检人
    h5_eval_review: { value: 678759, label: 'h5对话评估者' }, // h5对话评估者
    img_blind_review: { value: 678662, label: '图片盲评者' }, // 图片盲评者
  },
};

// 盘古角色映射map-rtx暴露
export const ALL_RTX_PANGU_ROLE_ID_MAP: any = {
  development: {
    pro_operator: { value: 284949, label: '开发运营' }, // 技术运维/产品运营
    blind_review: { value: 285687, label: '模型盲评者' }, // 模型盲评
    mark: { value: 281963, label: '生产者' }, // 生产
    review: { value: 281964, label: '质检者' }, // 质检
    sampling: { value: 281965, label: '抽检者' }, // 抽检
    check: { value: 281966, label: '验收者' }, // 验收
    project_manager: { value: 281962, label: '项目经理' }, // 项目经理
    image_manage: { value: 306055, label: '图片管理' }, // 图片管理
    tts_blind_review: { value: 306593, label: '语音包盲评者' }, // 语音包盲评
    corpus_tts_blind_review: { value: 308976, label: 'TTS盲评者' }, // TTS盲评者
    corpus_tts_blind_review_manage: { value: 308977, label: 'TTS盲评管理员' }, // TTS盲评管理员
    corpus_tts_compared_review: { value: 309987, label: 'TTS对比评估者' }, // TTS对比评估者
    corpus_tts_compared_review_manage: { value: 309986, label: 'TTS对比评估管理员' }, // TTS对比评估管理员
    corpus_img_model_review: { value: 314062, label: '图片模型横评者' }, // 图片模型横评者
    corpus_img_model_review_manage: { value: 314063, label: '图片模型横评管理员' }, // 图片模型横评管理员
    corpus_img_model_review_inspect: { value: 671297, label: '图片模型横评质检员' }, // 图片模型横评质检员
    corpus_pipeline_manage: { value: 675391, label: '语料管线管理' }, // 语料管线管理
    corpus_pipeline_project_manage: { value: 677726, label: '语料管线-项目经理' }, // 语料管线-项目经理
    corpus_pipeline_project_mark: { value: 677727, label: '语料管线-生产者' }, // 语料管线-生产者
    corpus_pipeline_project_review: { value: 677728, label: '语料管线-质检人' }, // 语料管线-质检人
    h5_eval_review: { value: 678757, label: 'h5对话评估者' }, // h5对话评估者
    h5_eval_review_manage: { value: 678758, label: 'h5对话评估管理员' }, // h5对话评估-管理者
    img_blind_review: { value: 678637, label: '图片盲评者' }, // 图片盲评者
    img_blind_review_manage: { value: 678638, label: '图片盲评管理员' }, // 图片盲评管理员
  },
  production: {
    blind_review: { value: 285684, label: '模型盲评者' }, // 模型盲评
    pro_operator: { value: 284950, label: '开发运营' }, // 技术运维/产品运营
    mark: { value: 284945, label: '生产者' }, // 生产
    review: { value: 284946, label: '质检者' }, // 质检
    sampling: { value: 284947, label: '抽检者' }, // 抽检
    check: { value: 284948, label: '验收者' }, // 验收
    project_manager: { value: 284944, label: '项目经理' }, // 项目经理
    image_manage: { value: 306056, label: '图片管理' }, // 图片管理
    tts_blind_review: { value: 306594, label: '语音包盲评者' }, // 语音包盲评
    corpus_tts_blind_review: { value: 308974, label: 'TTS盲评者' }, // TTS盲评者
    corpus_tts_blind_review_manage: { value: 308975, label: 'TTS盲评管理员' }, // TTS盲评管理员
    corpus_tts_compared_review: { value: 309989, label: 'TTS对比评估者' }, // TTS对比评估者
    corpus_tts_compared_review_manage: { value: 309988, label: 'TTS对比评估管理员' }, // TTS对比评估管理员
    corpus_img_model_review: { value: 314060, label: '图片模型横评者' }, // 图片模型横评者
    corpus_img_model_review_manage: { value: 314061, label: '图片模型横评者' }, // 图片模型横评管理员
    corpus_img_model_review_inspect: { value: 671296, label: '图片模型横评质检员' }, // 图片模型横评质检员
    corpus_pipeline_manage: { value: 675392, label: '语料管线管理' }, // 语料管线管理
    corpus_pipeline_project_manage: { value: 677729, label: '料管线-项目经理' }, // 语料管线-项目经理
    corpus_pipeline_project_mark: { value: 677730, label: '语料管线-生产者' }, // 语料管线-生产者
    corpus_pipeline_project_review: { value: 677731, label: '语料管线-质检人' }, // 语料管线-质检人
    h5_eval_review: { value: 678759, label: 'h5对话评估者' }, // h5对话评估者
    h5_eval_review_manage: { value: 678760, label: 'h5对话评估管理员' }, // h5对话评估-管理者
    img_blind_review: { value: 678662, label: '图片盲评者' }, // 图片盲评者
    img_blind_review_manage: { value: 678663, label: '图片盲评管理员' }, // 图片盲评管理员
  },
};

const env = process.env.NODE_ENV?.toLowerCase();
export const PANGU_AUTH_ID_MAP = ALL_PANGU_AUTH_ID_MAP[env];
export const PANGU_WX_ROLE_ID_MAP: any = ALL_WX_PANGU_ROLE_ID_MAP[env];
export const PANGU_RTX_ROLE_ID_MAP: any = ALL_RTX_PANGU_ROLE_ID_MAP[env];

export const USER_STATUS_MAP = {
  error: -1,
  noUser: 0, // redis无用户
  unApprovedInRedis: 1, // redis用户表未审批
  noAuthInPangu: 2, // 盘古未授权
  approvedInRedis: 3, // 盘古未授权
  approved: 4, // 盘古已授权
  rejected: 5, // 被redis审批驳回
  isExpired: 6, // 登录过期
};

export const REDIS_USER_LOGIN_TYPE_MAP = { rtx: 1, wx: 2 };

export const REDIS_USER_LOGIN_TYPE = [
  {
    label: 'wx',
    value: REDIS_USER_LOGIN_TYPE_MAP.wx,
  },
  {
    label: 'rtx',
    value: REDIS_USER_LOGIN_TYPE_MAP.rtx,
  },
];

export const QA_REVIEW_COLUMN_MAP = {
  task_type: {
    nameZH: '任务类型',
    type: 'select',
    options: {
      1: '盲评',
      2: '竞品',
    },
  },
};
export enum OcrPlatForm {
  PF_XINGYE = 1, // 星野
  PF_MAOXIANG = 2, // 猫箱
  PF_WX = 3, // 微信
  PF_YUANBAO = 4, // 元宝
}

// 语料oct截图来源平台
export const ocrPlatformList = [
  { value: OcrPlatForm.PF_XINGYE, label: '星野' },
  { value: OcrPlatForm.PF_MAOXIANG, label: '猫箱' },
  { value: OcrPlatForm.PF_WX, label: '微信' },
  { value: OcrPlatForm.PF_YUANBAO, label: '元宝' },
];

export enum QA_REVIEW_MAP {
  BLIND = 1, // 盲评
  COMPETITOR = 2, // 竞品
}

// 选项枚举
export const REVIEW_SAME_OPTION = {
  SAME: 'same',
};

export const ORDER_TYPE = {
  REVERSE: 0, // 反转
  NORMAL: 1, // 正常
};

/**
 * 无 mark 权限时的兜底跳转规则（按优先级排列）
 * 每项 authKeys 中任意一个权限命中即跳转到对应 path
 */
export const AUTH_REDIRECT_ROUTES: {
  authKeys: (keyof (typeof ALL_PANGU_AUTH_ID_MAP)['development'])[];
  path: string;
}[] = [
  { authKeys: ['cai_blind_review'], path: '/review/cai_blind_review' },
  { authKeys: ['tts_blind_review'], path: '/review/tts_review' },
  { authKeys: ['corpus_tts_blind_review'], path: '/review/corpus_tts_review' },
  { authKeys: ['corpus_tts_compared_review'], path: '/review/compared_tts_review' },
  { authKeys: ['corpus_img_model_review'], path: '/review/img_model_review' },
  { authKeys: ['corpus_pipeline_manage'], path: '/pipeline/crawl' },
  {
    authKeys: ['corpus_pipeline_project_manage', 'corpus_pipeline_project_mark', 'corpus_pipeline_project_review'],
    path: '/pipeline/project-manage',
  },
  { authKeys: ['h5_eval_review'], path: '/review/h5_bot_chat_review' },
  { authKeys: ['img_blind_review'], path: '/review/img_review' },
];
